import { render, staticRenderFns } from "./fictionList.vue?vue&type=template&id=75976368&"
import script from "./fictionList.vue?vue&type=script&lang=js&"
export * from "./fictionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports